export const mutations = {
  setIsUserAuthenticated(state, authenticationState) {
    state.isAuthenticated = authenticationState;
  },

  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
};
